import React, { ReactNode } from 'react';
import TextWithImageComponent from '@fuww/library/src/TextWithImage';
import Button from '@fuww/library/src/Button';
import Image from '../Image';
import LinkAndAnchor from '../LinkAndAnchor';

interface TextWithImageProperties {
  buttonHref?: string;
  buttonLabel?: string;
  buttonRoute?: string;
  description: ReactNode | string;
  imagePosition?: 'left' | 'right';
  imageUrls: string[];
  title: string;
  srcSet: string;
  buttonVariant?: 'contained' | 'outlined';
}

const TextWithImage = ({
  buttonHref,
  buttonLabel,
  buttonRoute,
  description,
  imagePosition,
  imageUrls,
  title,
  srcSet,
  buttonVariant,
}: TextWithImageProperties) => {
  const imageUrl = imageUrls.at(-1);

  return (
    <TextWithImageComponent
      imagePosition={imagePosition}
      title={title}
      description={description}
      image={
        imageUrl && (
          <Image
            src={imageUrl}
            alt={title}
            objectFit="cover"
            sizes="(min-width: 840px) 460px, calc(100vw - 2rem)"
            placeholder={imageUrls[0]}
            srcSet={srcSet}
          />
        )
      }
      button={
        buttonLabel && (buttonRoute || buttonHref) && (
        <LinkAndAnchor
          href={buttonHref}
          route={buttonRoute}
          passHref
          useRouter={!buttonHref}
        >
          <Button variant={buttonVariant ?? 'outlined'} disableElevation>
            {buttonLabel}
          </Button>

        </LinkAndAnchor>
        )
      }
    />
  );
};

export default TextWithImage;
